export enum FieldEnum {
  AdministrationPublique = 'administration_publique',
  AdministrationScolaireEtUniversitaire = 'administration_scolaire_et_universitaire',
  AeronautiqueEtAerospatiale = 'aeronautique_et_aerospatiale',
  AffairesEtrangeres = 'affaires_etrangeres',
  Agriculture = 'agriculture',
  AgroAlimentaire = 'agro_alimentaire',
  ArchitectureEtUrbanisme = 'architecture_et_urbanisme',
  Armee = 'armee',
  ArticlesDeLuxeEtBijouterie = 'articles_de_luxe_et_bijouterie',
  ArticlesDeSport = 'articles_de_sport',
  Arts = 'arts',
  ArtsEtArtisanat = 'arts_et_artisanat',
  ArtsVivants = 'arts_vivants',
  AssociationsEtOrganisationsSocialesEtSyndicales = 'associations_et_organisations_sociales_et_syndicales',
  Assurances = 'assurances',
  AutomatismesIndustriels = 'automatismes_industriels',
  Avocats = 'avocats',
  Banques = 'banques',
  Bibliotheques = 'bibliotheques',
  BiensDeConsommation = 'biens_de_consommation',
  BiensEtEquipementsPourLesEntreprises = 'biens_et_equipements_pour_les_entreprises',
  Biotechnologie = 'biotechnologie',
  CapitalRisqueEtFondsLbo = 'capital_risque_et_fonds_lbo',
  CentresDeRecherches = 'centres_de_recherches',
  ChantiersNavals = 'chantiers_navals',
  Chimie = 'chimie',
  CollectivitesPubliquesEtTerritoriales = 'collectivites_publiques_et_territoriales',
  CommerceDeDetail = 'commerce_de_detail',
  CommerceDeGros = 'commerce_de_gros',
  CommerceEtDeveloppementInternational = 'commerce_et_developpement_international',
  CompagnieAerienneAviation = 'compagnie_aerienne_aviation',
  Comptabilite = 'comptabilite',
  ConfectionEtMode = 'confection_et_mode',
  ConseilEnManagement = 'conseil_en_management',
  Construction = 'construction',
  ContenusRedactionnels = 'contenus_redactionnels',
  Cosmetiques = 'cosmetiques',
  DefenseEtEspace = 'defense_et_espace',
  Design = 'design',
  DesignGraphique = 'design_graphique',
  Divertissements = 'divertissements',
  Edition = 'edition',
  ElaborationDeProgrammes = 'elaboration_de_programmes',
  Elevage = 'elevage',
  EmballagesEtConteneurs = 'emballages_et_conteneurs',
  EnseignementSuperieur = 'enseignement_superieur',
  EntreposageStockage = 'entreposage_stockage',
  EnvironnementEtEnergiesRenouvelables = 'environnement_et_energies_renouvelables',
  EquipementsCollectifs = 'equipements_collectifs',
  EquipementsEtServicesDeLoisirs = 'equipements_et_services_de_loisirs',
  EquipementsFerroviaires = 'equipements_ferroviaires',
  EquipementsMedicaux = 'equipements_medicaux',
  EtudesDeMarche = 'etudes_de_marche',
  EtudesRecherche = 'etudes_recherche',
  ExternalisationDElocalisation = 'externalisation_d_elocalisation',
  FilmsDAnimation = 'films_d_animation',
  FormationAgrave = 'formation_agrave',
  FormationPrimaireSecondaire = 'formation_primaire_secondaire',
  FormationProfessionnelle = 'formation_professionnelle',
  GenieCivil = 'genie_civil',
  GestionDePortefeuilles = 'gestion_de_portefeuilles',
  GestionDesAssociationsEtFondations = 'gestion_des_associations_et_fondations',
  GrandeDistribution = 'grande_distribution',
  HopitauxEtCentresDeSoins = 'hopitaux_et_centres_de_soins',
  HotellerieEtHebergement = 'hotellerie_et_hebergement',
  Humanitaire = 'humanitaire',
  Immobilier = 'immobilier',
  ImmobilierCommercial = 'immobilier_commercial',
  ImportEtExport = 'import_et_export',
  ImprimerieReproduction = 'imprimerie_reproduction',
  IndustrieAutomobile = 'industrie_automobile',
  IndustrieBoisEtPapiers = 'industrie_bois_et_papiers',
  IndustrieComposantsElectriquesElectroniques = 'industrie_composants_electriques_electroniques',
  IndustrieDuCinema = 'industrie_du_cinema',
  IndustriePharmaceutique = 'industrie_pharmaceutique',
  IndustrieTextile = 'industrie_textile',
  IngenierieDuMecenat = 'ingenierie_du_mecenat',
  IngenierieMecaniqueOuIndustrielle = 'ingenierie_mecanique_ou_industrielle',
  InstitutionsJudiciaires = 'institutions_judiciaires',
  InstitutionsReligieuses = 'institutions_religieuses',
  Internet = 'internet',
  JeuxDArgentEtCasinos = 'jeux_d_argent_et_casinos',
  JeuxElectroniques = 'jeux_electroniques',
  LogicielsInformatiques = 'logiciels_informatiques',
  LogistiqueEtChaineDApprovisionnement = 'logistique_et_chaine_d_approvisionnement',
  LoisirsVoyagesEtTourisme = 'loisirs_voyages_et_tourisme',
  MachinesEtEquipements = 'machines_et_equipements',
  MandatLegislatif = 'mandat_legislatif',
  MandatPolitique = 'mandat_politique',
  MarchesDesCapitaux = 'marches_des_capitaux',
  MarketingEtPublicite = 'marketing_et_publicite',
  MateriauxDeConstruction = 'materiaux_de_construction',
  MaterielInformatique = 'materiel_informatique',
  MatieresPremieres = 'matieres_premieres',
  MedecinesAlternatives = 'medecines_alternatives',
  MediasEnLigne = 'medias_en_ligne',
  MediasRadioEtTelediffuses = 'medias_radio_et_telediffuses',
  MessageriesEtFret = 'messageries_et_fret',
  Meubles = 'meubles',
  MinesEtMictaux = 'mines_et_mictaux',
  MuseesEtInstitutionsCulturelles = 'musees_et_institutions_culturelles',
  Musique = 'musique',
  Nanotechnologies = 'nanotechnologies',
  OrganisationDEvenements = 'organisation_d_evenements',
  PartiPolitique = 'parti_politique',
  Peche = 'peche',
  PetroleEtEnergie = 'petrole_et_energie',
  Photographie = 'photographie',
  Plastiques = 'plastiques',
  PoliceGendarmerie = 'police_gendarmerie',
  PolitiquesPubliques = 'politiques_publiques',
  PresseEcrite = 'presse_ecrite',
  ProductionAudiovisuelle = 'production_audiovisuelle',
  ProduitsElectroniquesGrandPublic = 'produits_electroniques_grand_public',
  ProfessionsMedicales = 'professions_medicales',
  Recrutement = 'recrutement',
  ReglementExtrajudiciaireDeConflits = 'reglement_extrajudiciaire_de_conflits',
  RelationsPubliquesEtCommunication = 'relations_publiques_et_communication',
  ReseauxInformatiques = 'reseaux_informatiques',
  RessourcesHumaines = 'ressources_humaines',
  Restaurants = 'restaurants',
  RestaurationCollective = 'restauration_collective',
  SanteFormeEtBienEtre = 'sante_forme_et_bien_etre',
  SecteurLaitier = 'secteur_laitier',
  SecteurMedicoPsychologique = 'secteur_medico_psychologique',
  SecuriteCivile = 'securite_civile',
  SecuriteEtEnquetes = 'securite_et_enquetes',
  SecuriteInformatiqueEtDesReseaux = 'securite_informatique_et_des_reseaux',
  SemiConducteurs = 'semi_conducteurs',
  ServicesALaPersonne = 'services_a_la_personne',
  ServicesAuxConsommateurs = 'services_aux_consommateurs',
  ServicesDInformation = 'services_d_information',
  ServicesDInvestissement = 'services_d_investissement',
  ServicesFinanciers = 'services_financiers',
  ServicesJuridiques = 'services_juridiques',
  ServicesPourLEnvironnement = 'services_pour_l_environnement',
  Sports = 'sports',
  Tabac = 'tabac',
  TechnologiesEtServicesDeLInformation = 'technologies_et_services_de_l_information',
  TechnologiesSansFil = 'technologies_sans_fil',
  Telecommunications = 'telecommunications',
  TraductionEtAdaptation = 'traduction_et_adaptation',
  TransportsMaritimes = 'transports_maritimes',
  TransportsRoutiersEtFerroviaires = 'transports_routiers_et_ferroviaires',
  VerresCeramiquesEtCiments = 'verres_ceramiques_et_ciments',
  Veterinaire = 'veterinaire',
  VinsEtSpiritueux = 'vins_et_spiritueux',
}
